import { Block } from '@attom';

import CS from './Pagination.module.scss';

export const Pagination = ({
	// box Control
	boxClass = '',
	boxSize = '',
	boxSpace = '',
	//
	pageSize = 10,
	pageIndex = 0,
	itemIndex = 0,
	total = 0,
	onChange = null,
}) => {
	const pageCount = Math.ceil(total / pageSize);
	const currentPage = pageIndex || Math.floor((itemIndex + pageSize - 1) / pageSize);

	const prevPageCount = currentPage - 1 > 4 ? 4 : currentPage - 1;
	const nextPageCount = pageCount - 4 >= currentPage ? 4 : pageCount - currentPage;

	if (!total || total < 1 || pageCount <= 1) return null;
	if (!pageIndex && !itemIndex) return;

	const changeHandler = (index) => {
		if (onChange) onChange(index);
	};

	return (
		<Block boxClass={boxClass} boxSize={boxSize} boxSpace={boxSize}>
			<div className={CS.container}>
				{currentPage > 1 && (
					<>
						<button className={CS.button} _status='jump' onClick={() => changeHandler(1)}>
							<i className='fa fa-angle-double-right' />
						</button>
						<button
							className={CS.button}
							_status='jump'
							onClick={() => changeHandler(pageIndex ? currentPage - 1 : itemIndex - pageSize)}
						>
							<i className='fa fa-angle-right' />
						</button>
					</>
				)}
				{new Array(prevPageCount).fill('').map((item, i) => (
					<button
						onClick={() =>
							changeHandler(
								pageIndex
									? i + currentPage - prevPageCount
									: (i + currentPage - prevPageCount) * pageSize - pageSize + 1,
							)
						}
						className={CS.button}
						key={i}
						_status='deactive'
					>
						{i + currentPage - prevPageCount}
					</button>
				))}

				<button className={CS.button} _status='active'>
					{currentPage}
				</button>
				{new Array(nextPageCount).fill('').map((item, i) => (
					<button
						onClick={() => changeHandler(pageIndex ? currentPage + i + 1 : pageSize * (currentPage + i) + 1)}
						className={CS.button}
						key={i}
						_status='deactive'
					>
						{currentPage + i + 1}
					</button>
				))}
				{currentPage < pageCount && (
					<>
						<button
							className={CS.button}
							_status='jump'
							onClick={() => changeHandler(pageIndex ? currentPage + 1 : itemIndex + pageSize)}
						>
							<i className='fa fa-angle-left' />
						</button>
						<button
							className={CS.button}
							_status='jump'
							onClick={() => changeHandler(pageIndex ? pageCount : pageCount * pageSize - pageSize + 1)}
						>
							<i className='fa fa-angle-double-left' />
						</button>
					</>
				)}
			</div>
		</Block>
	);
};
